/* eslint-disable no-console */
import { handleErrors } from './ErrorActions';
import * as userDataApi from '../api/user-data';

export const FETCH_FAVORITES = 'Favorites/FETCH_FAVORITES';
export const FETCH_FAVORITES_SUCCESS = 'Favorites/FETCH_FAVORITES_SUCCESS';

const fetchFavoritesSuccess = (data) => ({
  type: FETCH_FAVORITES_SUCCESS,
  payload: { data },
});

export const fetchFavorites = () => async (dispatch) => {
  dispatch({
    type: FETCH_FAVORITES,
  });

  try {
    const apiData = await userDataApi.getFavorites();

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(fetchFavoritesSuccess(apiData.favorites));
  } catch (error) {
    console.log(`fetchFavorites() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const toggleFavorite = (data) => async (dispatch, getState) => {
  try {
    const { favorites } = getState();
    const findFavorite = ({ EntityType, EntityKey }) =>
      EntityType === data.entityType && EntityKey === data.entityKey;

    let apiData;

    if (favorites.data.findIndex(findFavorite) === -1) {
      apiData = await userDataApi.addFavorite(data);
    } else {
      apiData = await userDataApi.removeFavorite(data);
    }

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(fetchFavorites());
  } catch (error) {
    console.log(`toggleFavorite() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};
